import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";

const useReCaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getReCaptchaToken = async (action) => {
    if (!executeRecaptcha) {
      console.error("reCAPTCHA not ready");
      return null;
    }

    try {
      const token = await executeRecaptcha(action);    
      return token;
    } catch (error) {
      console.error("Error during captcha verification:", error);
      alert("An error occurred during captcha verification.");
      return null;
    }
  };

  return { getReCaptchaToken };
};

export default useReCaptcha;
